// services/participantes/motivosService.js
import axios from "axios";
import config from "../../config";

// Cambia la baseUrl para que apunte a /api/motivos en lugar de /api/participantes/motivos
const baseUrl = `${config.baseUrl}/api/motivos`;

// services/participantes/motivosService.js
export async function getMotivosOtroByPadreId(motivoPadreId, numeroIntento) {
  try {
    let url = `${baseUrl}/otro/${motivoPadreId}`;
    
    // Agregar parámetro de número de intento si existe
    if (numeroIntento !== undefined) {
      url += `?numeroIntento=${numeroIntento}`;
    }
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error en getMotivosOtroByPadreId:", error);
    throw error;
  }
}

export async function getMotivoOtroById(id) {
  const response = await axios.get(`${baseUrl}/otro/detalle/${id}`);
  return response.data;
}